import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { auth } from '@/api/firebaseInit';
import firebase from 'firebase';
Vue.use(Router);
const router =  new Router({
  base: '/',
  mode: 'hash',
  linkActiveClass: 'active',
  routes: paths
});
// router gards

router.beforeEach((to, from, next) => {
  const currentUser = auth.currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) {
    const loginpath = window.location.pathname;   
    next({
      path: '/login',
      query: {
        from: loginpath
      }
    });
  } else if (!requiresAuth && currentUser) {
    next("defaultView");
  } else {
    next();
  }
});

/*router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if NO logged user
    if (!(auth.currentUser)) {
      // Go to login
      next({
        path: '/login',
        query: {
          //redirect: to.fullPath
        }
      });
    } else {
      // Proceed to route
      // this.$store.dispatch('fetchChangedSigninUserInfo');
      next();
    }
  } else if (to.matched.some(record => record.meta.public)) {
    // Check if NO logged user
    if (auth.currentUser) {
      // Go to login
      next({
        path: '/:',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      // Proceed to route
      next();
    }
  } else {
    // Proceed to route
    next();
  }
}); */

router.afterEach((to, from) => {
  // ...
  NProgress.done();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js